import { CircleCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import img from '../../images/AntoineMeyssonn1i.jpg';

const CommandePublique = () => {
  return (
    <div className="mb-20">
      {' '}
      <section
        className="p-5 text-center lg:p-32 bg-black/70 bg-blend-overlay "
        style={{
          backgroundImage: `url(${img})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <h1 className="text-3xl font-bold text-center text-white lg:text-7xl">
          {'Commande publique'}
        </h1>
      </section>
      <div className="container mt-32 mb-10">
        <h1 className="font-bold text-black lg:text-2xl">CONSULTATION EN COURS</h1>
        <hr className="w-full h-1 bg-primary" />
        <p className="mt-4 text-justify text-black">
           AQUAVESC, comme tous les acheteurs publics, lance régulièrement des consultations et
          publie des avis d'appel public à concurrence (A.A.P.C.) pour les achats qu'il effectue,
          qu'il s'agisse de travaux, de fournitures ou de services.
        </p>
        <p className="mt-5 text-black">
          Pour consulter les avis de publicité et les dossiers de consultation des entreprises
          (DCE) du syndicat mixte AQUAVESC, rendez-vous sur le profil acheteur dédié en suivant le
          lien suivant :
          <Link to="https://aquavesc.e-marchespublics.com">
             <div className="text-blue-500">https://aquavesc.e-marchespublics.com</div>
          </Link>
        </p>
      </div>
      <div className="bg-bg_aquavesc">
        <div className="container p-5 lg:p-28">
          <h1 className="font-bold text-black">Cette platforme vous permet de :</h1>
          <div className="flex flex-col mt-10">
            <div className="flex">
              <div>
                {' '}
                <CircleCheck className="w-5 h-5 text-primary" />
              </div>
              <div className="ml-3">Rechercher les consultations en cours</div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <CircleCheck className="w-5 h-5 text-primary" />
              </div>
              <div className="ml-3">Visualiser les avis de publicité</div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <CircleCheck className="w-5 h-5 text-primary" />
              </div>
              <div className="ml-3">Télécharger les pièces du dossier de consultation</div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <CircleCheck className="w-5 h-5 text-primary" />
              </div>
              <div className="ml-3">Poser une question en cours de consultation</div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <CircleCheck className="w-5 h-5 text-primary" />
              </div>
              <div className="ml-3">Déposer des offres électroniques</div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-20 ">
        <h1 className="text-2xl font-bold text-center text-black lg:text-5xl">
          Quelques recommandations
        </h1>
        <p className="mt-4 font-semibold text-black">
          Si vous souhaitez répondre à une consultation, vous devez créer un compte sur la 
          <span className="underline">plateforme</span> pour consulter et proposer votre candidature
          et votre offre. Pour ce faire, il vous est recommandé de :
        </p>

        <div className="">
          <div className="flex flex-col mt-10">
            <div className="flex">
              <div>
                {' '}
                <div className="w-5 h-5 rounded-full bg-primary"></div>
              </div>
              <div className="ml-3">
                Veiller à fournir l'ensemble des pièces demandées par le règlement de consultation
                ou la lettre de consultation ou l’AAPC.
              </div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <div className="w-5 h-5 rounded-full bg-primary"></div>
              </div>
              <div className="ml-3">
                {' '}
                Veiller à respecter toutes les exigences du dossier de consultation des entreprises,
                et notamment celles du règlement de la consultation et du cahier des charges (CCAP
                et CCTP ou CCP notamment).
              </div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <div className="w-5 h-5 rounded-full bg-primary"></div>
              </div>
              <div className="ml-3">
                En cas de difficulté de compréhension du dossier de consultation, de ne pas hésiter
                à poser vos questions via le profil d'acheteur, avant la date limite qui vous est
                indiquée pour poser lesdites questions.
              </div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <div className="w-5 h-5 rounded-full bg-primary"></div>
              </div>
              <div className="ml-3">
                Assurez-vous de déposer votre offre avant la date et l'heure limites de remise des
                offres : à défaut, elle ne pourrait être ouverte.
              </div>
            </div>

            <div className="flex mt-3">
              <div>
                {' '}
                <div className="w-5 h-5 rounded-full bg-primary"></div>
              </div>
              <div className="ml-3">
                En cas d’oubli d’un document, veuillez effectuer un nouveau dépôt en joignant
                l’ensemble des pièces de votre offre (seule la dernière offre reçue est ouverte en
                cas de dépôts successifs).
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommandePublique;
